import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Container, Col, Row, Label } from 'reactstrap'
import DataWrapper from '../../../principal/containers/DataWrapper'
import FiltroUnidadesLiberadasArmador from '../components/FiltroUnidadesLiberadasArmador'
import UnidadesLiberadasArmadorStore from '../stores/UnidadesLiberadasArmadorStore'
import Footer from '../../../comum/components/Footer'
import FooterContent from '../../../comum/components/FooterContent'
import { IconeCarregar, IconeDelete, IconeCheck} from '../../../comum/components/Icones'
import ModalAviso from '../../../comum/components/ModalAviso'
import Toggle from 'react-toggle'
import FormInputSimples from '../../../comum/components/FormInputSimples'
import FormSelectSimples from '../../../comum/components/FormSelectSimples';

@inject("store")
@DataWrapper
@observer
export class UnidadesLiberadasArmador extends Component {

    constructor(props) {
        super(props)
        
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;

        this.controller = new UnidadesLiberadasArmadorStore()
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Unidades Liberadas Armador x Tipo Cntr");
        this.appStore.showTopbar(true);

        //TODO: Provavelmente botar um loading indicando que estou recebendo as informações desta requisição
        this.controller.listarUnidadesArmadoresTipo();
        this.controller.listarArmadores();
        this.controller.listarTiposCntr();
    }

    modalMensagem() {
        return this.controller.alerta !== "" && 
        <ModalAviso onClickFechar={this.controller.fecharModalAlerta}>
            <h2>
                {this.controller.alerta}
            </h2>
        </ModalAviso>
    }

    render() {
        if(this.controller.loadingDefault) {
            return <Row className="justify-content-center">
                    <IconeCarregar tamanho="2x" />
                </Row>
        } else {
            return (<React.Fragment>
                    <div className="form-wrapper">
                    <Container fluid>
                    
                        <FiltroUnidadesLiberadasArmador controller={this.controller} />
                        {this.modalMensagem()}
                            {
                                this.controller.listaDefault && this.controller.listaDefault.map((item, index) => {
                                    return(
                                        <Row key={index} className="align-items-center">
                                            <FormSelectSimples xs={12} sm={12} md={4} lg={4} xl={4}
                                                titulo="Armador"
                                                itens={this.controller.listaArmadores}
                                                dado={item.armador}
                                                bloqueado={item.id && item.id > 0}
                                                onChange={(event) => this.controller.setValorDefault(event, "armador", item, index)}
                                                />
                                            
                                            <FormSelectSimples xs={10} sm={10} md={3} lg={3} xl={3}
                                                titulo="Tipo Cntr"
                                                itens={this.controller.listaTiposCntr}
                                                dado={item.tipoCntr}
                                                onChange={(event) => this.controller.setValorDefault(event, "tipoCntr", item, index)}
                                            />
                                            
                                            <FormInputSimples  xs={10} sm={10} md={3} lg={3} xl={3} type="number"
                                                titulo="Quantidade"
                                                dado={ item.qtd }
                                                limiteMaximo={10}
                                                onChange={ (event) => this.controller.setValorDefault(event, "qtd", item, index) } 
                                            />

                                            <Toggle 
                                                className="custom-toggle" 
                                                icons={false} 
                                                defaultChecked={item.ativo} 
                                                onChange={() => this.controller.setValorDefault(event, "ativo", item, index)} 
                                            />
                                            
                                            <Col xs={1} sm={1} md={1} lg={1} xl={1} className="pl-0 mt-1">
                                                <IconeDelete className="icone-delete-borda" tamanho="3x" onClick={ () => this.controller.excluirUnidadesArmador(item, index) }/>
                                            </Col>
                                        </Row>
                                    )
                                })
                            }
                            <Row>
                                    <Button className="btn-primary" onClick={this.controller.addArmadorNovo}>
                                        + Adicionar armador
                                    </Button>
                            </Row>
                    </Container>                    
                    <Footer>
                        <FooterContent>
                        {this.controller.itens !== null &&
                            <div className="justify-content-between">
                                <div>
                                    <b>{this.controller.listaDefault && this.controller.listaDefault.length}</b> {this.controller.itens === 1 ? 'item encontrado' :'itens encontrados'} -
                                    <a onClick={this.controller.listarUnidadesArmadoresTipo}>Atualizar Lista</a>
                                </div>
                            </div>
                        }
                        </FooterContent>
                        <FooterContent className="right-pos">
                            <Button className="btn-primary" onClick={this.controller.salvarListaDefault}>SALVAR ALTERAÇÕES</Button>
                        </FooterContent>
                    </Footer>
                    </div>  
                    </React.Fragment>
            )
        }
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/depot-unidades-liberadas/telas/UnidadesLiberadasArmador.js